<template>
  <v-dialog v-model="show" max-width="800px">
    <v-card>
      <v-card-title class="modal-title">
        <h3>{{ inscripcion?.nick }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" class="close-button">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- El correo, para escribirle: abre la aplicación de correo -->
      <a
        v-if="inscripcion?.email"
        :href="`mailto:${inscripcion.email}`"
        class="d-block px-4 pb-2 text-body-2 text-medium-emphasis email"
      >
        {{ inscripcion.email }}
      </a>
      <v-divider></v-divider>

      <v-card-text>
        <v-list dense>
          <!-- Estado Lista -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="list-item-title">
                LISTA
              </v-list-item-title>
              <v-select
                v-model="localInscripcion.estadoLista"
                :items="ESTADOS_LISTA"
                item-title="corto"
                item-value="valor"
                label="Estado"
                dense
                hide-details
                @change="
                  logChange('estadoLista', localInscripcion.estadoLista!)
                "
              ></v-select>
            </v-list-item-content>
          </v-list-item>

          <!-- Estado Pago -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="list-item-title">
                PAGO
              </v-list-item-title>
              <v-select
                v-model="localInscripcion.esPago"
                :items="pagoOptions"
                item-title="texto"
                item-value="valor"
                label="Estado"
                dense
                hide-details
                @input="logChange('esPago', localInscripcion.esPago!)"
              ></v-select>
            </v-list-item-content>
          </v-list-item>

          <!-- Botón para ver la lista -->
          <v-list-item>
            <v-list-item-content v-if="!showLista">
              <v-btn color="orange" variant="tonal" @click="toggleLista">
                Mostrar Lista
              </v-btn>
            </v-list-item-content>
            <v-list-item-content v-else>
              <v-btn color="orange" variant="tonal" @click="toggleLista">
                Ocultar Lista
              </v-btn>
            </v-list-item-content>
          </v-list-item>

          <!-- Contenido de la lista -->
          <v-expand-transition>
            <v-list-item v-if="showLista">
              <v-list-item-content>
                <h3>{{ localInscripcion.ejercito }}</h3>
                <v-spacer class="my-3"></v-spacer>
                <template v-if="listaBase64">
                  <img
                    :src="listaBase64"
                    alt="Lista"
                    style="max-width: 100%; height: auto"
                  />
                </template>
                <template v-else>
                  <p>No hay lista disponible</p>
                </template>
              </v-list-item-content>
            </v-list-item>
          </v-expand-transition>

          <!-- Botón para subir/modificar lista -->
          <v-list-item>
            <v-btn color="primary" variant="tonal" @click="showModalLista()">
              Envia/modifica su lista
            </v-btn>
          </v-list-item>

          <!-- Botón para eliminar la inscripcion: cerrado el torneo ya no sale nadie -->
          <v-list-item v-if="!cerrado">
            <v-list-item-content>
              <v-btn
                color="red"
                variant="tonal"
                @click="eliminarInscripcion(inscripcion?.idInscripcion!)"
              >
                Eliminar inscripción
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Modal response estado pago -->
  <ModalSuccess
    :isVisible="showSuccessModalPago"
    message="Estado del pago actualizado."
    @update:isVisible="showSuccessModalPago = $event"
  />

  <!-- Modal response estado lista -->
  <ModalSuccess
    :isVisible="showSuccessModalLista"
    message="Estado de la lista actualizado."
    @update:isVisible="showSuccessModalLista = $event"
  />

  <!-- Modal response eliminar inscripcion -->
  <ModalSuccess
    :isVisible="showSuccessModalEliminar"
    message="Inscripción eliminada."
    @update:isVisible="showSuccessModalEliminar = $event"
  />

  <!-- Modal response si error -->
  <ModalError
    :isVisible="showErrorModal"
    message="No se ha podido actualizar la inscripción. Contacta con el administrador."
    @update:isVisible="showErrorModal = $event"
  />

  <!-- Modal response eliminar inscripcion -->
  <ModalSuccess
    :isVisible="showSuccessModalSubirLista"
    message="Lista subida con éxito."
    @update:isVisible="showSuccessModalSubirLista = $event"
  />

  <!-- Modal para subir la lista del jugador -->
  <ModalListaGestion
    :isVisible="showModificarLista"
    :idLista="localInscripcion.idLista!"
    @update:isVisible="showModificarLista = $event"
    @enviarLista="handleEnviarLista"
  />

  <!-- Modal de Carga -->
  <v-dialog v-model="isLoading" hide-overlay persistent>
    <v-card class="progress-card">
      <v-progress-circular
        indeterminate
        color="primary"
        size="70"
      ></v-progress-circular>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ESTADOS_LISTA } from "@/utils/estadoLista";
import { InscripcionTorneoCreadoDTO } from "@/interfaces/Torneo";
import {
  cancelarInscripcion,
  updateEstadoLista,
  updateEstadoPago,
} from "@/services/InscripcionesService";
import { defineProps, ref, watch, defineEmits } from "vue";
import { useTorneoCerrado } from "@/composables/useTorneoCerrado";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import {
  getlistaTorneo,
  modificarListaTorneo,
  subirListaTorneo,
} from "@/services/ListasService";
import {
  CrearListaTorneoRequestDTO,
  ListaTorneoRequestDTO,
  ModificarListaTorneoRequestDTO,
  RequesListaDTO,
} from "@/interfaces/Lista";
import ModalListaGestion from "./ModalListaGestion.vue";
import { ArmyDTO } from "@/interfaces/Army";

// Definir las propiedades y eventos
const props = defineProps<{
  inscripcion: InscripcionTorneoCreadoDTO;
}>();
const cerrado = useTorneoCerrado();

// ModalDetalleInscripcion.vue
const emit = defineEmits<{
  (e: "close"): void;
  (
    e: "update-inscripcion",
    payload: { field: keyof InscripcionTorneoCreadoDTO; value: unknown }
  ): void;
  (e: "eliminar-inscripcion", idInscripcion: number): void;
}>();

const show = ref<boolean>(true);
const showLista = ref<boolean>(false);
const localInscripcion = ref({ ...props.inscripcion });
const isLoading = ref<boolean>(false);
const listaBase64 = ref<string>();
const listaText = ref<string>("");
const ejercito = ref<ArmyDTO>();

// Se guarda SI o NO; se enseña como en el resto de la aplicación
const pagoOptions = [
  { valor: "NO", texto: "No pagado" },
  { valor: "SI", texto: "Pagado" },
];

const showSuccessModalPago = ref<boolean>(false);
const showSuccessModalLista = ref<boolean>(false);
const showSuccessModalEliminar = ref<boolean>(false);
const showSuccessModalSubirLista = ref<boolean>(false);

const showModificarLista = ref<boolean>(false);

const showErrorModal = ref<boolean>(false);

// Registrar el cambio y actualizar en la base de datos
const logChange = async (
  field: "estadoLista" | "esPago",
  value: string | boolean
) => {
  isLoading.value = true;
  try {
    //lista
    if (field === "estadoLista") {
      let estado: string;
      if (value == "NO ENTREGADA") estado = "NO ENTREGADA";
      else if (value == "ENTREGADA") estado = "ENTREGADA";
      else if (value == "ILEGAL") estado = "ILEGAL";
      else estado = "OK";
      await updateEstadoLista({
        idInscripcion: localInscripcion.value.idInscripcion,
        estadoLista: estado,
      });
      showSuccessModalLista.value = true;
      isLoading.value = false;
      emit("update-inscripcion", { field, value: estado });

      //Pago
    } else if (field === "esPago") {
      let estado: string;
      if (value == "NO") estado = "NO";
      else estado = "SI";
      await updateEstadoPago({
        idInscripcion: localInscripcion.value.idInscripcion,
        esPago: estado,
      });
      showSuccessModalPago.value = true;
      isLoading.value = false;
      emit("update-inscripcion", { field, value: estado });
    }
  } catch (error) {
    console.error(`Error actualizando ${field}:`, error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
  }
};

// Solo cuando el organizador lo cambia en esta inscripción: al abrir la de otro jugador también cambian los valores,
// y se volvían a guardar y le llegaba al jugador un correo sin haber cambiado nada
watch(
  () => [localInscripcion.value.idInscripcion, localInscripcion.value.estadoLista] as const,
  ([id, nuevo], [idAnterior, anterior]) => {
    if (id === idAnterior && nuevo !== anterior) {
      logChange("estadoLista", nuevo!);
    }
  }
);

watch(
  () => [localInscripcion.value.idInscripcion, localInscripcion.value.esPago] as const,
  ([id, nuevo], [idAnterior, anterior]) => {
    if (id === idAnterior && nuevo !== anterior) {
      logChange("esPago", nuevo!);
    }
  }
);

// Cerrado tocando fuera o con Escape, como con la X: así no se queda abierto por debajo con el jugador anterior
watch(show, abierto => {
  if (!abierto) emit("close");
});

const toggleLista = async () => {
  showLista.value = !showLista.value;

  if (showLista.value) {
    isLoading.value = true;
    const requestLista: ListaTorneoRequestDTO = {
      idTorneo: localInscripcion.value.idTorneo,
      idUsuario: localInscripcion.value.idUsuario,
    };
    try {
      const response = await getlistaTorneo(requestLista);
      listaBase64.value = response.data.listaData;
    } catch (error) {
      console.error("Error al recuperar la lista.");
    } finally {
      isLoading.value = false;
    }
  }
};

const eliminarInscripcion = async (idInscripcion: number) => {
  try {
    const response = await cancelarInscripcion(idInscripcion);

    if (response.request?.status === 200) {
      showSuccessModalEliminar.value = true;
      emit("eliminar-inscripcion", idInscripcion);
    } else {
      showErrorModal.value = true;
    }
  } catch {
    showErrorModal.value = true;
  } finally {
    show.value = false;
    emit("close");
  }
};

const close = () => {
  show.value = false;
  emit("close");
};

const showModalLista = () => {
  showModificarLista.value = true;
};

const handleEnviarLista = async (newLista: RequesListaDTO) => {
  listaText.value = newLista.listaData;
  ejercito.value = newLista.ejercito;
  await enviarLista(newLista);
};

const enviarLista = async (newLista: RequesListaDTO) => {
  isLoading.value = true;

  if (localInscripcion.value.idLista && localInscripcion.value.idLista != 0) {
    const requestLista: ModificarListaTorneoRequestDTO = {
      idLista: localInscripcion.value.idLista,
      listaData: newLista.listaData,
      ejercito: newLista.ejercito,
    };
    try {
      await modificarListaTorneo(requestLista);
      showSuccessModalSubirLista.value = true;
    } catch {
      showErrorModal.value = true;
    } finally {
      isLoading.value = false;
    }
  } else {
    const requestLista: CrearListaTorneoRequestDTO = {
      idInscripcion: localInscripcion.value.idInscripcion,
      idUsuario: localInscripcion.value.idUsuario,
      idTorneo: localInscripcion.value.idTorneo,
      listaData: newLista.listaData,
      ejercito: newLista.ejercito,
      nick: "",
    };
    try {
      await subirListaTorneo(requestLista);
      showSuccessModalSubirLista.value = true;
    } catch {
      showErrorModal.value = true;
    } finally {
      isLoading.value = false;
    }
  }
};

// Watch para actualizar la inscripción local cuando cambie la inscripción original
watch(
  () => props.inscripcion,
  (newInscripcion) => {
    localInscripcion.value = { ...newInscripcion };
    show.value = true;
  }
);

// Watch para detectar cuando se cierra el modal de éxito
watch(
  () => showSuccessModalSubirLista.value,
  (newValue, oldValue) => {
    if (oldValue && !newValue) {
      recargarPagina();
    }
  }
);

const recargarPagina = () => {
  window.location.reload();
};
</script>

<style scoped>
.email {
  overflow-wrap: anywhere;
  color: inherit;
}
.modal-title {
  display: flex;
  align-items: center;
  align-items: center;
  font-size: 20px;
}

.modal-title h3 {
  margin: 0; /* Elimina márgenes para un mejor centrado */
}

.list-item-title {
  display: flex;
  align-items: center;
  font-weight: 500;
  margin-bottom: 8px;
}

.close-button {
  margin-left: auto;
}

.v-list-item {
  margin-bottom: 16px;
}

.lotr-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100%;
}
</style>
